import { useState } from "react";
import { useAuth } from "@/admin/AdminApp";
import { Btn, Card, ErrorMsg, Field, inputCls } from "@/admin/ui";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-alt px-4 py-10">
      <Card className="w-full max-w-md p-8">
        <img src="/images/dms-home-improvements-logo.webp" alt="DMS Home Improvements" width="600" height="213" className="mx-auto h-12 w-auto" />
        <h1 className="mt-6 text-center text-2xl font-bold text-navy">Dashboard login</h1>
        <p className="mt-2 text-center text-sm text-body">Private — for DMS Home Improvements only.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <Field label="Email">
            <input data-testid="login-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          </Field>
          <Field label="Password">
            <input data-testid="login-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          </Field>
          <ErrorMsg error={error} />
          <Btn type="submit" data-testid="login-submit" disabled={busy} className="w-full">
            {busy ? "Logging in…" : "Log in"}
          </Btn>
        </form>
      </Card>
    </div>
  );
}
